import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ICONS, IconName, IconShape } from './icon-registry';

/**
 * Renders a line icon from the Polilo set.
 *
 *   <app-icon name="bell" [size]="21" />
 *
 * Colour follows `currentColor`, so set `color` on the parent.
 */
@Component({
  selector: 'app-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg
      [attr.viewBox]="'0 0 24 24'"
      [attr.width]="size()"
      [attr.height]="size()"
      [attr.aria-hidden]="label() ? null : 'true'"
      [attr.role]="label() ? 'img' : null"
      [attr.aria-label]="label() || null"
      fill="none"
      stroke="currentColor"
      [attr.stroke-width]="strokeWidth()"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      @for (shape of shapes(); track $index) {
        @switch (shape.k) {
          @case ('path') {
            <svg:path [attr.d]="$any(shape).d" />
          }
          @case ('circle') {
            <svg:circle [attr.cx]="$any(shape).cx" [attr.cy]="$any(shape).cy" [attr.r]="$any(shape).r" />
          }
          @case ('rect') {
            <svg:rect
              [attr.x]="$any(shape).x"
              [attr.y]="$any(shape).y"
              [attr.width]="$any(shape).w"
              [attr.height]="$any(shape).h"
              [attr.rx]="$any(shape).rx ?? 0"
            />
          }
          @case ('line') {
            <svg:line
              [attr.x1]="$any(shape).x1"
              [attr.y1]="$any(shape).y1"
              [attr.x2]="$any(shape).x2"
              [attr.y2]="$any(shape).y2"
            />
          }
        }
      }
    </svg>
  `,
  styles: `
    :host {
      display: inline-flex;
      flex-shrink: 0;
      line-height: 0;
    }
  `,
})
export class IconComponent {
  readonly name = input.required<IconName>();
  readonly size = input(20);
  readonly strokeWidth = input(1.9);
  /** Set only when the icon carries meaning on its own. */
  readonly label = input('');

  protected readonly shapes = computed<readonly IconShape[]>(() => ICONS[this.name()] ?? []);
}
